var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-object-to-link" },
    [
      _c(
        "CompassFormItem",
        {
          staticClass: "search-object-to-link__search-input",
          attrs: { label: _vm.$t.__("activities.labels.find_and_link_object") }
        },
        [
          _c("CompassInput", {
            ref: "searchInput",
            attrs: {
              isEraseable: "",
              placeholder: _vm.$t.__("common.actions.search"),
              prefixIcon: "search"
            },
            on: { input: _vm.handleQueryInput },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.query
        ? _c("CompassEmptyState", {
            attrs: {
              title: _vm.emptyStateData.title,
              caption: _vm.emptyStateData.caption,
              illustrationPath: _vm.emptyStateData.illustrationPath
            }
          })
        : [
            _c("SearchBarFilters", {
              attrs: {
                filtersList: [
                  "company",
                  "contact",
                  "opportunity",
                  "document",
                  "individual"
                ],
                currentFilter: _vm.currentFilter,
                permissions: _vm.permissions
              },
              on: { change: _vm.handleFilterChange }
            }),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "div",
                  _vm._l(3, function(index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "result-container__loader typographies-paragraph-medium-regular"
                      },
                      [
                        _c("CompassSkeleton", {
                          staticClass: "result-container__loader-image",
                          attrs: { variant: "square" }
                        }),
                        _vm._v(" "),
                        _c("CompassSkeleton", {
                          staticClass: "result-container__loader-text",
                          attrs: { lines: 2 }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm.resultsCount === 0
              ? _c(
                  "div",
                  { staticClass: "result-container__no-results" },
                  [
                    _c("CompassIcon", {
                      attrs: { size: "small", icon: "search-no-result" }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t.__("common.labels.no_result")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              : [
                  _vm._l(_vm.searchResults.companies.items, function(company) {
                    return _c(
                      "SearchResultsCompany",
                      _vm._b(
                        {
                          key: "company_" + company.id,
                          attrs: {
                            context: "link-to-activity",
                            link: "javascript:void(0)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleClickItem(
                                "company",
                                company.type,
                                company
                              )
                            }
                          }
                        },
                        "SearchResultsCompany",
                        company,
                        false
                      )
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.searchResults.contacts.items, function(contact) {
                    return _c(
                      "SearchResultsContact",
                      _vm._b(
                        {
                          key: "contact_" + contact.id,
                          attrs: {
                            context: "link-to-activity",
                            link: "javascript:void(0)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleClickItem(
                                "contact",
                                "contact",
                                contact
                              )
                            }
                          }
                        },
                        "SearchResultsContact",
                        contact,
                        false
                      )
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.searchResults.opportunities.items, function(
                    opportunity
                  ) {
                    return _c(
                      "SearchResultsOpportunity",
                      _vm._b(
                        {
                          key: "opportunity_" + opportunity.id,
                          attrs: {
                            context: "link-to-activity",
                            link: "javascript:void(0)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleClickItem(
                                "opportunity",
                                "opportunity",
                                opportunity
                              )
                            }
                          }
                        },
                        "SearchResultsOpportunity",
                        opportunity,
                        false
                      )
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.searchResults.individuals.items, function(
                    individual
                  ) {
                    return _c(
                      "SearchResultsIndividual",
                      _vm._b(
                        {
                          key: "individual_" + individual.id,
                          attrs: {
                            context: "link-to-activity",
                            link: "javascript:void(0)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleClickItem(
                                "individual",
                                individual.type,
                                individual
                              )
                            }
                          }
                        },
                        "SearchResultsIndividual",
                        individual,
                        false
                      )
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.searchResults.documents.items, function(document) {
                    return _c(
                      "SearchResultsDocument",
                      _vm._b(
                        {
                          key: "document_" + document.id,
                          attrs: {
                            context: "link-to-activity",
                            link: "javascript:void(0)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleClickItem(
                                "document",
                                document.sub_type,
                                document
                              )
                            }
                          }
                        },
                        "SearchResultsDocument",
                        document,
                        false
                      )
                    )
                  })
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }